'use client'

import { Button, useDevice } from '@lune-fe/lune-ui-lib'
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight'
import { FC } from 'react'

import BlueBox from '@/components/BlueBox'

export enum Sector {
    LOGISTICS = 'logistics',
    PAYMENTS = 'spend management',
}

const RequestDemo: FC<{ sector?: Sector; text?: string }> = ({ sector, text }) => {
    const { smScreen } = useDevice()

    return (
        <BlueBox
            text={
                text ??
                `Build a climate positive legacy by integrating precise carbon emission tracking, reporting, accounting, and reduction
 ${sector ? 'into your ' + sector : ' platform'}`
            }
            rightSide={
                <Button
                    href="/request-a-demo"
                    sx={{ width: smScreen ? '100%' : 'auto' }}
                    variant={'contained'}
                    leftIcon={<ArrowCircleRightIcon />}
                >
                    Request a demo
                </Button>
            }
        />
    )
}

export default RequestDemo
